import { call, put, takeEvery } from "redux-saga/effects";
import { toaNhaApi } from "../../../api/category/toaNhaApi";
import { IToaNha } from "../../../model/respone/category/IToaNha";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eToaNhaActionIds,
  IToaNhaActionTypes,
} from "../../action-types/category/IToaNhaActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.toaNha;
export function* toaNhaSaga(): any {
  yield takeEvery(eToaNhaActionIds.LOAD_START, loadWorker);
  yield takeEvery(eToaNhaActionIds.SAVE_START, saveWorker);
  yield takeEvery(eToaNhaActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(toaNhaApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IToaNhaActionTypes): any {
  let res: IBaseRespone = yield call(toaNhaApi.SelectAll);
  let payload = action.payload as IToaNha;
  if (payload.id_nha > 0) {
    res = yield call(toaNhaApi.Update, payload);
  } else {
    res = yield call(toaNhaApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* deleteWorker(action: IToaNhaActionTypes): any {
  const res: IBaseRespone = yield call(
    toaNhaApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}
